module.exports = __webpack_public_path__ + "static/media/gb-wls.12441f65.svg";